import { render, staticRenderFns } from "./DhmeProjectsDashboard.vue?vue&type=template&id=1a2f5003&scoped=true"
import script from "./DhmeProjectsDashboard.vue?vue&type=script&lang=js"
export * from "./DhmeProjectsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f5003",
  null
  
)

export default component.exports